import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="h360-header">
      <div className="header-container">
        <div className="logo-section">
          <a href="https://h360ressources.com" target="_blank" rel="noopener noreferrer" className="logo-link">
            <img src={`${process.env.PUBLIC_URL || ''}/logo.gif`} alt="H360 Resources" className="logo-image" />
          </a>
        </div>
        
        <nav className="nav-links">
          <a href="#home" className="nav-link active">Home</a>
          <a href="#jobs" className="nav-link">Available jobs</a>
          <a href="#immigration" className="nav-link">Immigration</a>
          <a href="#events" className="nav-link">Events</a>
        </nav>

        <div className="header-actions">
          {/* <button className="action-btn candidate-btn">
            Candidate space <span className="dropdown-arrow">▼</span>
          </button>
          <button className="action-btn business-btn">
            Business space <span className="dropdown-arrow">▼</span>
          </button> */}
          
          <div className="language-selector">
            <span className="lang-option">FR</span>
            <span className="lang-option active">EN</span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;


